<template>
	<div>
		<vue-headful
			title="Preguntas Frecuentes"
			description="Consulta las preguntas más frecuentes acerca de los servicios de VARELAB."
		/>
		<div class="front front--page">
			<div v-parallax="0.1" v-parallax.centerX class="bg-parallax bg-parallax--preguntas"></div>
			<div class="container">
				<h1 class="title title--big color--white">Preguntas Frecuentes</h1>
				<div class="separator separator--white"></div>
			</div>
		</div>

		<div class="page-body">
			<div class="container">
				<div class="page-block">
					<b class="color--boston-blue">¿Cuál es el listado de coberturas con las que trabajan?</b>
					<div class="open-sans">En Varelab trabajamos con más de 100 coberturas de salud, para ver el listado completo <router-link to="/coberturas" class="color--blue">hacer clic aquí</router-link></div>
				</div>
				<div class="page-block">
					<b class="color--boston-blue">¿Quiero formar parte de su equipo de profesionales, puede enviar mi CV?</b>
					<div class="open-sans">Para sumarte a nuestra base de datos para futuras búsquedas laborales <a href="#" data-toggle="modal" data-target="#cvModal" class="color--blue">hacer clic aquí.</a> </div>
				</div>
				<div class="page-block">
					<b class="color--boston-blue">¿Cómo hago para conocer el precio de un estudio? </b>
					<div class="open-sans">Podés dirigirte a nuestro laboratorio con la orden médica del estudio a realizarte o enviar escaneada dicha orden con tus datos por correo electrónico a <a href="mailto:info@varelab.com.ar">info@varelab.com.ar</a> </div>
				</div>
				<div class="page-block">
					<b class="color--boston-blue">¿Quiere conocer el listado de estudios qué puedo realizarme en el laboratorio?</b>
					<div class="open-sans">En Varelab realizamos más de 2000 tipos de estudios, si el estudio que buscás no se encuentra en el siguiente listado, no dudes en consultarnos a cualquiera de nuestros canales de contacto. <br> <b class="color--gray">Facebook: <a href="https://www.facebook.com/LaboratorioVarelab/" target="_blank">Varelab</a> - <a href="mailto:info@varelab.com.ar">info@varelab.com.ar</a> - 4287-6172</b></div>
				</div>
				<div class="page-block">
					<b class="color--boston-blue">¿ Cuáles son los estudios de urgencia con resultados en el acto? </b>
					<ul class="list">
						<li>Test de embarazo</li>
						<li>Fauces rápido</li>
						<li>Grupo y factor</li>
						<li>Orina completa</li>
					</ul>
				</div>
				<div class="page-block">
					<b class="color--boston-blue">¿Cuál es la preparación previa al estudio que debo realizarme? </b>
					<div class="open-sans">Para conocer los estudios que necesitan preparación previa por parte del paciente hacé clic aquí, si tu estudio no se encuentra en el listado no necesita preparación previa. </div>
				</div>
				<div class="page-block">
					<b class="color--boston-blue">¿Con cuánta anticipación necesito sacar turno para realizarme un estudio?</b>
					<div class="open-sans">En varelab realizamos estudios por orden de llegada, sin turnos previos. </div>
				</div>
				<div class="page-block">
					<b class="color--boston-blue">¿En qué horario puedo visitar el laboratorio para realizarme un análisis, tengo que llevar alguna documentación?</b>
					<div class="open-sans">Nuestro laboratorio se encuentra abierto de lunes a viernes de 8 a 17hs, las extracciones se realizan durante todo el día presentando la orden médica, el documento de identidad y credencial de la cobertura de salud.</div>
				</div>
				<div class="page-block">
					<b class="color--boston-blue"> ¿Soy particular y no cuento con obra social ni prepaga puedo atenderme igual?</b>
					<div class="open-sans">Sí, en Varelab atendemos pacientes particulares, por obras sociales y prepagas.</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'preguntas',
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Servicios/Preguntas.vue